import { configureStore, type DevToolsEnhancerOptions } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';

import { webapi } from '@/api/webapi.ts';
import { listenerMiddleware } from '@/store/listenerMiddleware.ts';
import { reduxFatalityMiddleware } from '@/store/reduxFatalityMiddleware';
import { rootReducer } from '@/store/rootReducer.ts';
import { loggerMiddleware } from '@/store/loggerMiddleware.ts';

const devTools: DevToolsEnhancerOptions = {
  name: `Forex-${location.host}`,
  actionsDenylist: [
    'esp/espPriceReceived',
    'cash/cashRfsQuoteReceived',
    'option/optionRfsQuoteReceived',
    'option/optionRfsHeartbeat',
    'swap/swapRfsQuoteReceived',
    'flexiForward/flexiForwardRfsQuoteReceived',
    '__rtkq/unfocused',
    '__rtkq/focused',
    'webapi/internalSubscriptions/subscriptionsUpdated',
  ],
  traceLimit: 200,
};

const devToolsEnabled = import.meta.env.DEV || new URLSearchParams(window.location.search).has('devtools');

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(webapi.middleware)
      .concat(reduxFatalityMiddleware)
      // .concat(logHttpMiddleware)
      // .concat(e2eLoggerMiddleware)
      .concat(loggerMiddleware)
      .prepend(listenerMiddleware.middleware),
  devTools: devToolsEnabled ? devTools : false,
});

setupListeners(store.dispatch);

export type AppStore = typeof store;

export type AppState = ReturnType<typeof rootReducer>;

export type GetAppState = typeof store.getState;
export type AppDispatch = typeof store.dispatch;
